import type { GetAdminFirms } from '@cloudFunctions/types/admin/getAdminFirms';
import type { GetAdminMatters } from '@cloudFunctions/types/admin/getAdminMatters';
import type {
  ListSubcollectionsRequest,
  ListSubcollectionsResponse,
} from './adminBackendContracts';
import { invokeBackendRoute } from '@/backend/invoke';
import type { CreateFirmOnboardingForms } from '@cloudFunctions/types/clientToFirmPayments/createFirmOnboardingForms';
import type { UpdateIdentity } from '@cloudFunctions/functions/payments/updateIdentity';
import type { UpdateMerchant } from '@cloudFunctions/functions/payments/updateMerchant';
import type { UpdateIdentityRequestData } from '@/backend/routes/updateIdentity';
import type { UpdateMerchantRequestData } from '@/backend/routes/updateMerchant';
import type { ListIdentities } from '@cloudFunctions/types/payments/listIdentities';
import type { ListMerchants } from '@cloudFunctions/types/payments/listMerchants';
import type { ListPaymentInstruments } from '@cloudFunctions/types/payments/listPaymentInstruments';
import type { ListTransfers } from '@cloudFunctions/types/payments/listTransfers';

export type {
  GetAdminFirms,
  GetAdminMatters,
  ListSubcollectionsRequest,
  ListSubcollectionsResponse,
  CreateFirmOnboardingForms,
  UpdateIdentity,
  UpdateMerchant,
  ListIdentities,
  ListMerchants,
  ListPaymentInstruments,
  ListTransfers,
};

export const getAdminFirms = async (props?: GetAdminFirms.Props) => {
  return invokeBackendRoute<GetAdminFirms.SuccessPayload, GetAdminFirms.Props>(
    'getAdminFirms',
    props,
  );
};

export const getAdminMatters = async (props: GetAdminMatters.Props) => {
  return invokeBackendRoute<
    GetAdminMatters.SuccessPayload,
    GetAdminMatters.Props
  >('getAdminMatters', props);
};

export const listSubcollections = async (
  requestData: ListSubcollectionsRequest,
): Promise<ListSubcollectionsResponse> => {
  return invokeBackendRoute<
    ListSubcollectionsResponse,
    ListSubcollectionsRequest
  >('listSubcollections', requestData);
};

export const createFirmOnboardingForms = async (
  requestData: CreateFirmOnboardingForms.RequestData,
): Promise<CreateFirmOnboardingForms.Result> => {
  return invokeBackendRoute<
    CreateFirmOnboardingForms.Result,
    CreateFirmOnboardingForms.RequestData
  >('createFirmOnboardingForms', requestData);
};

export const updateIdentity = async (
  requestData: UpdateIdentityRequestData,
): Promise<UpdateIdentity.Result> => {
  return invokeBackendRoute<UpdateIdentity.Result, UpdateIdentityRequestData>(
    'updateIdentity',
    requestData,
  );
};

export const updateMerchant = async (
  requestData: UpdateMerchantRequestData,
): Promise<UpdateMerchant.Result> => {
  return invokeBackendRoute<UpdateMerchant.Result, UpdateMerchantRequestData>(
    'updateMerchant',
    requestData,
  );
};

export const listIdentities = async (
  requestData: ListIdentities.RequestData,
): Promise<ListIdentities.Result> => {
  return invokeBackendRoute<ListIdentities.Result, ListIdentities.RequestData>(
    'listIdentities',
    requestData,
  );
};

export const listMerchants = async (
  requestData: ListMerchants.RequestData,
): Promise<ListMerchants.Result> => {
  return invokeBackendRoute<ListMerchants.Result, ListMerchants.RequestData>(
    'listMerchants',
    requestData,
  );
};

export const listPaymentInstruments = async (
  requestData: ListPaymentInstruments.RequestData,
): Promise<ListPaymentInstruments.Result> => {
  return invokeBackendRoute<
    ListPaymentInstruments.Result,
    ListPaymentInstruments.RequestData
  >('listPaymentInstruments', requestData);
};

export const listTransfers = async (
  requestData: ListTransfers.RequestData,
): Promise<ListTransfers.Result> => {
  return invokeBackendRoute<ListTransfers.Result, ListTransfers.RequestData>(
    'listTransfers',
    requestData,
  );
};
